<template>
  <el-table
    v-loading="tableLoad"
    :data="tableData"
    class="w100"
    border
    stripe
    :cell-style="cellStyle"
    :header-cell-style="headerCellStyle">
    <el-table-column label="序号" align="center" width="50px" type="index" />
    <el-table-column
      prop="fleetName"
      label="供应商名称"
      width="150"
      show-overflow-tooltip
      align="center" />
    <el-table-column
      prop="startName"
      label="起始区域"
      width="150px"
      show-overflow-tooltip
      align="center">
      <template slot-scope="scope">
        <span :style="{ paddingRight: scope.row.startType === 1 ? '30px' : '0px' }">
          {{ scope.row.startName }}
        </span>
        <i v-if="scope.row.startType === 1" class="port-icon" :title="scope.row.startPortName"
          >港</i
        >
      </template>
    </el-table-column>
    <el-table-column
      prop="deliveryName"
      label="交车区域"
      width="150px"
      align="center"
      show-overflow-tooltip>
      <template slot-scope="scope">
        <span :style="{ paddingRight: scope.row.deliveryType === 1 ? '30px' : '0px' }">
          {{ scope.row.deliveryName }}
        </span>
        <i v-if="scope.row.deliveryType === 1" class="port-icon" :title="scope.row.deliveryPortName"
          >港</i
        >
      </template>
    </el-table-column>
    <el-table-column prop="fleetCount" label="预装车数量" :formatter="convert0" align="center" />
    <el-table-column
      prop="surplusCount"
      label="实际装车数量"
      :formatter="convert0"
      align="center" />
    <el-table-column prop="entruckTime" label="预装车时间" show-overflow-tooltip align="center" />
    <el-table-column prop="driverState" label="分配车辆状态" align="center">
      <div slot-scope="scope">{{ scope.row.carCount ? '已分配' : '未分配' }}</div>
    </el-table-column>
    <el-table-column prop="state" label="任务状态" align="center">
      <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
    </el-table-column>
    <el-table-column label="操作" min-width="300" align="center">
      <template slot-scope="scope">
        <div>
          <el-button
            v-if="scope.row.fleetCount - scope.row.surplusCount > 0 && scope.row.status != 2"
            size="mini"
            class="resetBtn"
            type="primary"
            @click="btnClick(scope.row, '分配运输车')"
            >分配运输车
          </el-button>
          <el-button
            size="mini"
            class="searchBtn"
            type="primary"
            @click="btnClick(scope.row, '详情')"
            >详情
          </el-button>
          <el-button
            v-if="scope.row.status === 0"
            size="mini"
            type="primary"
            @click="btnClick(scope.row, '修改')"
            class="yellow-bg"
            >修改
          </el-button>
          <el-button
            v-if="scope.row.status === 1"
            size="mini"
            type="primary"
            @click="btnClick(scope.row, '完成')"
            >完成
          </el-button>
          <el-button
            v-if="scope.row.status === 0"
            size="mini"
            type="danger"
            @click="btnClick(scope.row, '删除')"
            >删除
          </el-button>
          <el-button
            v-if="scope.row.status === 2"
            size="mini"
            type="primary"
            @click="btnClick(scope.row, '修改交车地')"
            class="yellow-bg"
            >修改交车地
          </el-button>
          <el-button
            v-if="scope.row.status === 2 || scope.row.status === 1"
            size="mini"
            type="primary"
            @click="btnClick(scope.row, '修改供应商')"
            class="yellow-bg"
            >修改供应商
          </el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: 'carTable',
    data() {
      return {
        tableLoad: false,
        tableData: [],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
      };
    },
    computed: {
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待开始';
            case 1:
              return '执行中';
            case 2:
              return '已完成';
          }
        };
      },
    },
    methods: {
      // 单元格样式
      cellStyle(row) {
        if (row.row.startType === 1 && row.column.label === '装车地') {
          return {
            color: '#7F7F7F',
            'font-size': '13px',
            height: '52px',
            'padding-right': '30px !important',
          };
        } else if (row.row.deliveryType === 1 && row.column.label === '交车地') {
          return {
            color: '#7F7F7F',
            'font-size': '13px',
            height: '52px',
            'padding-right': '30px !important',
          };
        } else {
          return {
            color: '#7F7F7F',
            'font-size': '13px',
            height: '52px',
          };
        }
      },
      // 将null转换为0
      convert0(row, column, cellValue) {
        if (cellValue) {
          return cellValue;
        } else {
          return '0';
        }
      },
      // 分配运输车
      async btnClick(row, label) {
        this.$emit('btnClick', {
          row: row,
          label: label,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  i.port-icon {
    position: absolute;
    display: inline-block;
    left: 120px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    text-align: center;
    line-height: 20px;
    background: red;
    color: #fff;
    border-radius: 50%;
  }
</style>
